import React, { useState, useEffect } from 'react';
import ApiService from '../../../services/apiService';
import { toast } from 'react-toastify';
import moment from 'moment';
import Tooltip from '../../purchaseRequisition/tooltip';

const ItemGridGRN = ({ onRequisitionData, itemData, grnData, selectedPOData, currencyPrecision, setItemData, setLazyLoading,
    setOverallDiscount, grandTotal, setVatAmount, vatAmount,
    overallDiscount, setDiscountAmount, discountAmount, setGrandTotal }) => {
    const [columnWidths, setColumnWidths] = useState({
        srNo: 70,
        itemNo: 100,
        description: 130,
        specification: 120,
        qty: 70,
        uom: 130,
        inventoryQty: 130,
        balQty: 80,
        freeQty: 100,
        unitPrice: 120,
        discount: 100,
        calculatedAmount: 100,
        vatDesc: 100,
        vat: 80,
        vatAmount: 120,
        amount: 100,
        batchNo: 120,
        expDate: 130
    });
    const ResizableHeader = ({ column, children }) => {
        return (
            <th
                style={{
                    width: `${columnWidths[column]}px`,
                    minWidth: `${columnWidths[column]}px`,
                    position: 'relative'
                }}
            >
                {children}

                <span
                    className="resize-handle"
                    onMouseDown={(e) => startResize(e, column)}
                />
            </th>
        );
    };
    const [overallDiscountAmount, setOverallDiscountAmount] = useState(); // Amount
    const [rows, setRows] = useState([{
        requisitionNo: '',
        srno: '',
        recordId: '',
        ItemNo: '',
        itemDescription: '',
        specification: '',
        qty: '',
        uom: '',
        baseQty: '',
        baseAmount: '',
        amount: '',
        discount: '',
        vat: '',
        vatCode: '',
        vatDes: '',
        vatAmount: '',
        balQty: "",
        freeQty: "",
        convValue: '',
        discount: '',
        discountAmount: '',
        calculatedAmount: "",
        expDate: null,
        batchNo: "",
        inventoryAccountCode: "",
        inventoryAccountName: "",
    }]);

    const calculatedTotal = rows.reduce((sum, row) => {
        const amount = parseFloat(row?.amount) || 0;
        const vatAmount = parseFloat(row?.vatAmount) || 0;
        const discount = parseFloat(row?.discount) || 0;
        let final = overallDiscount === 0 ? ((amount + discount) - vatAmount) : (amount - vatAmount)

        return sum + (final);
    }, 0);
    const totalItemDiscount = rows.reduce((sum, row) => { return sum + Number(row?.discount || 0); }, 0);

    useEffect(() => {
        const grossAmount = rows.reduce(
            (sum, row) => sum + Number(row?.amount - row?.vatAmount || 0),
            0
        );

        const totalQty = rows.reduce(
            (sum, row) => sum + Number(row?.actualqty || 0),
            0
        );
        const qty = rows.reduce(
            (sum, row) => sum + Number(row?.qty || 0),
            0
        );
        const overallamount = rows.reduce(
            (sum, row) => sum + Number(row?.actualqty * row?.baseAmount),
            0
        );
        // Overall discount amount
        const discountam = (overallamount * overallDiscount) / 100;
        let overDiscountAmt = parseFloat(discountam)?.toFixed(3)
        const discountPerQty = totalQty > 0 ? discountam / totalQty : 0;
        const discountAmt = overallDiscount === 0 ? totalItemDiscount : (qty * discountPerQty);
        const discountamount = parseFloat(discountAmt)
        // Discount per qty

        // Amount after discount
        const amountAfterDiscount = calculatedTotal - discountAmt;

        // VAT - sum each row's actual VAT amount instead of applying a flat rate
        // const vatAmount = rows.reduce((sum, row) => sum + (Number(row?.vatAmount) || 0), 0);
        let vatAmount = 0;
        if (rows.length === 1) {

            const vatRate = rows[0]?.vat;
            vatAmount = (amountAfterDiscount * vatRate) / 100;
        } else {
            // Get unique VAT rates
            const uniqueVatRates = [
                ...new Set(rows.map((r) => Number(r?.vat || 0))),
            ];

            if (uniqueVatRates.length === 1) {
                // Same VAT on all rows
                const vatRate = uniqueVatRates[0];
                vatAmount = (amountAfterDiscount * vatRate) / 100;
            } else {
                // Different VAT rates
                vatAmount = rows.reduce(
                    (sum, row) => sum + Number(row?.vatAmount || 0),
                    0
                );
            }
        }
        // Grand Total
        const grandTotal = amountAfterDiscount + vatAmount;


        // Optional: update rows with per qty discount
        const updatedRows = rows.map((row) => ({
            ...row,
            discountPerQty,
        }));

        // Only if you want to save it in state
        // setRows(updatedRows);

        setDiscountAmount(discountamount);
        setOverallDiscountAmount(overDiscountAmt);
        setVatAmount(vatAmount);
        setGrandTotal(grandTotal);

        // If you need discountPerQty elsewhere
        // setDiscountPerQty(discountPerQty);

    }, [rows, overallDiscount, totalItemDiscount]);

    useEffect(() => {
        const getItems = async () => {
            try {
                const apiService = new ApiService();
                let vatParam = `?toPurchase=true`;
                const vat = await apiService.getApiParamater('GET_INV_TAX', vatParam);
                const formattedRowsitm = itemData.map(async (detail, index) => {
                    const selecteditms = await apiService.getApiParamater("GET_ITEM", `?ItemNo=${detail.itemCode}`);
                    const getGLAccounts = await apiService.getApiParamater("GET_ITEM_GL", `?ItemNo=${detail.itemCode}`);
                    let glAccount = getGLAccounts?.data?.result[0] || ""
                    let itm = selecteditms?.data?.result[0]
                    const discountdinal = (detail?.discount / detail?.qty) * detail?.balQty;
                    // let finalDiscount = discountdinal * detail?.balQty
                    const selectedVat = vat.data.result.find((tax) => tax.description === detail?.vatDesc);
                    debugger
                    return {
                        requisitionNo: detail?.requisitionNo,
                        srno: detail?.srno,
                        ItemNo: detail?.itemCode,
                        itemDescription: detail?.itemDescription,
                        uom: detail?.uom,
                        baseQty: 0,
                        qty: 0,
                        freeQty: detail?.extraQty || 0,
                        convValue: itm?.convToInvUOM || 0,
                        baseAmount: detail?.unitPrice?.toFixed(4),
                        vatDes: detail?.vatDesc,
                        vatCode: selectedVat?.recordId || '',
                        vat: detail?.vatPerc || 0,
                        vatAmount: 0,
                        originalDiscount: discountdinal?.toFixed(currencyPrecision || 3) || 0,
                        specification: detail ? detail?.specification : '',
                        amount: 0,
                        discount: detail?.discount?.toFixed(currencyPrecision || 3) || 0,
                        balQty: detail?.balQty || 0,
                        inventoryAccountCode: glAccount?.inventoryAccountCode || "",
                        inventoryAccountName: glAccount?.inventoryAccountName || "",
                        GRNAccountName: glAccount?.grnAccountName || "",
                        GRNAccountCode: glAccount?.grnAccountCode || "",
                        calculatedAmount: 0,
                        actualqty: detail?.qty,
                    };
                }).filter(row => row !== null);
                const formattedRows = await Promise.all(formattedRowsitm);
                if (formattedRows.length > 0) {
                    setRows(formattedRows);
                    setItemData(formattedRows)
                    onRequisitionData(formattedRows);
                    setLazyLoading(false)
                } else {
                    setRows(null);
                    setItemData(null)
                    onRequisitionData(null);
                    setLazyLoading(false)
                }
            } catch (error) {
                setRows(null);
                setItemData(null)
                onRequisitionData(null);
                setLazyLoading(false)
                console.error('Error fetching items:', error);
            }
        };

        if (itemData.length > 0) {
            getItems();
        }
    }, [itemData]);
    const handleQtyChange = (index, value) => {
        const newQty = Number(value);

        const row = rows[index];

        const balQty = Number(row.balQty);
        const unitPrice = Number(row.baseAmount);
        const vatPerc = Number(row.vat);
        const vatDes = row.vatDes;
        const UOM = row.convValue;

        if (newQty < 0) {
            toast.warning("Quantity cannot be less than 0.");
            return;
        }

        if (newQty > balQty) {
            toast.warning("Enter a quantity less than or equal to the balance quantity.");
            return;
        }

        // Save original discount only once

        const originalDiscount = row.originalDiscount !== undefined ? row.originalDiscount : Number(row.discount || 0);

        const discountdinal = newQty === 0 ? 0 : (originalDiscount * newQty) / balQty;
        const discount = discountdinal?.toFixed(currencyPrecision || 3)
        const grossAmount = (newQty * unitPrice)?.toFixed(currencyPrecision || 3);
        const afterDiscount = parseFloat(grossAmount) - parseFloat(discountdinal) || 0;
        const vatAmoun = parseFloat((afterDiscount * vatPerc) / 100);
        let vatAmount = vatAmoun?.toFixed(currencyPrecision || 3)

        const finalAmount = parseFloat(afterDiscount) + parseFloat(vatAmount);

        setRows(prevRows => {
            const newRows = [...prevRows];
            newRows[index] = {
                ...newRows[index],
                qty: newQty,
                baseQty: newQty || 0,
                discount,
                originalDiscount,
                calculatedAmount: afterDiscount,
                vatAmount,
                vatDes,
                amount: finalAmount,
            };

            return newRows;
        });
        setItemData(prevRows => {
            const newRows = [...prevRows];
            newRows[index] = {
                ...newRows[index],
                qty: newQty,
                baseQty: newQty || 0,
                discount,
                originalDiscount,
                calculatedAmount: afterDiscount?.toFixed(currencyPrecision || 3),
                vatAmount,
                vatDes,
                amount: finalAmount,
            };

            return newRows;
        });

    };
    const handleFreeQTChange = (index, value) => {
        const newQty = value || 0;
        const balQty = rows[index].balQty;
        const qty = rows[index].qty || 0;

        if (newQty < 0) {
            toast.warning('Quantity cannot be less than 0.');
            return;
        }

        setRows(prevRows => {
            const newRows = [...prevRows];
            newRows[index].freeQty = newQty;
            return newRows;
        });
        setItemData(prevRows => {
            const newRows = [...prevRows];
            newRows[index].freeQty = newQty;
            return newRows;
        });

    };
    const handleUnitPriceChange = (index, value) => {
        const unitPrice = value;
        const qty = rows[index].qty;
        const vatPerc = rows[index].vat;

        if (unitPrice < 0) {
            toast.warning('Quantity cannot be less than 0.');
            return;
        }

        const amountBeforeVat = unitPrice * qty;
        const vatAmount = (amountBeforeVat * vatPerc) / 100;
        let totalAmount;

        if (selectedPOData?.costCenter5 === "excluded") {
            totalAmount = amountBeforeVat + vatAmount;
        } else {
            totalAmount = amountBeforeVat;
        }

        setRows(prevRows => {
            const newRows = [...prevRows];
            newRows[index].baseAmount = unitPrice;
            newRows[index].amount = totalAmount;
            newRows[index].vatAmount = vatAmount;
            return newRows;
        });
    };
    const handleBatchNo = (index, value) => {
        const updatedRows = [...rows];
        updatedRows[index].batchNo = value;
        const updatedSelectedRows = rows.map((row, i) =>
            i === index ? { ...row, batchNo: value } : row
        );
        setRows(updatedSelectedRows);
        onRequisitionData(updatedSelectedRows);
    };
    const handleDateChange = (index, expDate) => {
        const updatedRows = [...rows];
        updatedRows[index].expDate = expDate;
        const updatedSelectedRows = rows.map((row, i) =>
            i === index ? { ...row, expDate: expDate } : row
        );
        setRows(updatedSelectedRows);
        onRequisitionData(updatedSelectedRows);
    };
    const preventNegativeSign = (e) => {
        if (e.key === "-" || e.key === "+") {
            e.preventDefault();
        }
    };
    const startResize = (e, column) => {
        e.preventDefault();

        const startX = e.clientX;
        const startWidth = columnWidths[column];

        const handleMouseMove = (event) => {
            const newWidth = Math.max(
                50,
                startWidth + (event.clientX - startX)
            );

            setColumnWidths(prev => ({
                ...prev,
                [column]: newWidth
            }));
        };

        const handleMouseUp = () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };
    const handleQtyKeyDown = (e, index) => {
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            const nextIndex = index + 1;
            if (nextIndex < rows.length) {
                const nextInput = document.getElementById(`qty-${nextIndex}`);
                if (nextInput) {
                    nextInput.focus();
                    nextInput.select();
                }
            }
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            const prevIndex = index - 1;
            if (prevIndex >= 0) {
                const prevInput = document.getElementById(`qty-${prevIndex}`);
                if (prevInput) {
                    prevInput.focus();
                    prevInput.select();
                }
            }
        } else if (e.key === '-' || e.key === '+') {
            e.preventDefault();
        }
    };

    const handleInputChange = async (index, fieldName, value) => {
        const updatedRows = await Promise.all(
            rows?.map(async (row, rowIndex) => {
                if (rowIndex !== index) return row;
                const updatedRow = { ...row, srno: ('0' + (index + 1)).slice(-2) };
                // validations

                if (fieldName === "calculatedAmount") {
                    const calculatedAmount = parseFloat(value) || 0;
                    const vatRate = Number(updatedRow?.vat || 0);

                    // const vatAmount = truncateAmount(
                    //   (calculatedAmount * vatRate) / 100,
                    //   currencyPrecision || 3
                    // );
                    let vatAmount = (calculatedAmount * vatRate) / 100;
                    const finalAmount = truncateAmount(
                        calculatedAmount + vatAmount,
                        currencyPrecision || 3
                    );

                    updatedRow.calculatedAmount = calculatedAmount;
                    updatedRow.vatAmount = vatAmount;
                    updatedRow.amount = finalAmount;

                    return updatedRow;
                }
                return updatedRow;
            })
        );

        setRows(updatedRows);
        setItemData(updatedRows);
    };
    const truncateAmount = (value, decimals = 3) => {
        const num = Number(value) || 0;
        const factor = Math.pow(10, decimals);

        return Math.trunc(num * factor) / factor;
    };
    return (
        <div>
            <div className="row mb-3">
                <div className="col-md-4">
                    <label>Discount %</label>
                    <input
                        type="number"
                        className="form-control"
                        value={overallDiscount}
                        disabled
                    />
                </div>
                <div className="col-md-4">
                    <label>Discount Amount</label>
                    <input
                        type="number"
                        className="form-control"
                        value={overallDiscountAmount}
                        disabled
                    />
                </div>
            </div>
            <div className='table-container p-1  p-2 mt-3 mb-3' style={{ overflowX: 'auto', height: "auto" }}>
                <table>
                    <thead className="dynoTable">
                        <tr>
                            <ResizableHeader column="srNo">Sr no</ResizableHeader>
                            <ResizableHeader column="itemNo">Item No</ResizableHeader>
                            <ResizableHeader column="description">Description</ResizableHeader>
                            <ResizableHeader column="specification">Item Specs</ResizableHeader>
                            <ResizableHeader column="qty">Qty</ResizableHeader>
                            <ResizableHeader column="uom">Packing UOM</ResizableHeader>
                            <ResizableHeader column="inventoryQty">Inventory Qty</ResizableHeader>
                            <ResizableHeader column="balQty">Bal Qty</ResizableHeader>
                            <ResizableHeader column="freeQty">Free Qty</ResizableHeader>
                            <ResizableHeader column="unitPrice">Unit Price</ResizableHeader>
                            <ResizableHeader column="discount">Discount</ResizableHeader>
                            <ResizableHeader column="calculatedAmount">Calculated Amount</ResizableHeader>
                            <ResizableHeader column="vatDesc">VAT Desc</ResizableHeader>
                            <ResizableHeader column="vat">VAT %</ResizableHeader>
                            <ResizableHeader column="vatAmount">VAT Amount</ResizableHeader>
                            <ResizableHeader column="amount">Amount</ResizableHeader>
                            <ResizableHeader column="batchNo">Batch No</ResizableHeader>
                            <ResizableHeader column="expDate">Exp Date</ResizableHeader>
                        </tr>
                    </thead>
                    <tbody>
                        {rows?.map((row, index) => (
                            <tr key={index}>

                                {/* Sr No */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.srNo}px`,
                                        minWidth: `${columnWidths.srNo}px`
                                    }}
                                >
                                    <input
                                        className="p-2"
                                        type="text"
                                        value={index + 1}
                                        disabled
                                        style={{ width: "100%", boxSizing: "border-box" }}
                                    />
                                </td>

                                {/* Item No */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.itemNo}px`,
                                        minWidth: `${columnWidths.itemNo}px`
                                    }}
                                >
                                    <input
                                        className="p-2"
                                        disabled
                                        value={row.ItemNo}
                                        style={{ width: "100%", boxSizing: "border-box" }}
                                    />
                                </td>

                                {/* Description */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.description}px`,
                                        minWidth: `${columnWidths.description}px`
                                    }}
                                >
                                    <input
                                        className="p-2"
                                        disabled
                                        value={row.itemDescription}
                                        style={{ width: "100%", boxSizing: "border-box" }}
                                    />
                                </td>

                                {/* Item Specs */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.specification}px`,
                                        minWidth: `${columnWidths.specification}px`
                                    }}
                                >
                                    <input
                                        className="p-2"
                                        disabled
                                        value={row.specification}
                                        style={{ width: "100%", boxSizing: "border-box" }}
                                    />
                                </td>

                                {/* Qty */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.qty}px`,
                                        minWidth: `${columnWidths.qty}px`
                                    }}
                                >
                                    <input
                                        id={`qty-${index}`}
                                        className="p-2"
                                        onWheel={(e) => e.target.blur()}
                                        type="number"
                                        style={{
                                            width: "100%",
                                            boxSizing: "border-box"
                                        }}
                                        value={row.qty}
                                        // onKeyDown={preventNegativeSign}
                                        max={row.balQty}
                                        onChange={(e) =>
                                            handleQtyChange(index, e.target.value)
                                        }
                                        onKeyDown={(e) => handleQtyKeyDown(e, index)}

                                    />
                                </td>

                                {/* Packing UOM */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.uom}px`,
                                        minWidth: `${columnWidths.uom}px`
                                    }}
                                >
                                    <input
                                        className="p-2"
                                        disabled
                                        value={row.uom}
                                        style={{ width: "100%", boxSizing: "border-box" }}
                                    />
                                </td>

                                {/* Inventory Qty */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.inventoryQty}px`,
                                        minWidth: `${columnWidths.inventoryQty}px`
                                    }}
                                >
                                    <input
                                        className="p-2"
                                        disabled
                                        value={row.baseQty}
                                        style={{ width: "100%", boxSizing: "border-box" }}
                                    />
                                </td>

                                {/* Bal Qty */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.balQty}px`,
                                        minWidth: `${columnWidths.balQty}px`
                                    }}
                                >
                                    <input
                                        className="p-2"
                                        disabled
                                        value={row.balQty || 0}
                                        style={{ width: "100%", boxSizing: "border-box" }}
                                    />
                                </td>

                                {/* Free Qty */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.freeQty}px`,
                                        minWidth: `${columnWidths.freeQty}px`
                                    }}
                                >
                                    <input
                                        className="p-2"
                                        onWheel={(e) => e.target.blur()}
                                        type="number"
                                        style={{
                                            width: "100%",
                                            boxSizing: "border-box"
                                        }}
                                        value={row.freeQty}
                                        onKeyDown={preventNegativeSign}
                                        max={row.freeQty}
                                        onChange={(e) =>
                                            handleFreeQTChange(index, e.target.value)
                                        }
                                    />
                                </td>

                                {/* Unit Price */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.unitPrice}px`,
                                        minWidth: `${columnWidths.unitPrice}px`
                                    }}
                                >
                                    <input
                                        className="p-2"
                                        onWheel={(e) => e.target.blur()}
                                        type="number"
                                        value={row.baseAmount}
                                        disabled
                                        onKeyDown={preventNegativeSign}
                                        onChange={(e) =>
                                            handleUnitPriceChange(index, e.target.value)
                                        }
                                        style={{
                                            width: "100%",
                                            boxSizing: "border-box"
                                        }}
                                    />
                                </td>

                                {/* Discount */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.discount}px`,
                                        minWidth: `${columnWidths.discount}px`
                                    }}
                                >
                                    <input
                                        className="p-2"
                                        type="text"
                                        value={row.discount}
                                        disabled
                                        style={{ width: "100%", boxSizing: "border-box" }}
                                    />
                                </td>

                                {/* Calculated Amount */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.calculatedAmount}px`,
                                        minWidth: `${columnWidths.calculatedAmount}px`
                                    }}
                                >
                                    <input
                                        className="p-2"
                                        type="number"
                                        onWheel={(e) => e.target.blur()}
                                        onKeyDown={preventNegativeSign}
                                        value={row?.calculatedAmount ?? ""}
                                        onChange={(e) =>
                                            handleInputChange(
                                                index,
                                                "calculatedAmount",
                                                e.target.value
                                            )
                                        }
                                        style={{
                                            width: "100%",
                                            boxSizing: "border-box"
                                        }}
                                    />
                                </td>

                                {/* VAT Desc */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.vatDesc}px`,
                                        minWidth: `${columnWidths.vatDesc}px`
                                    }}
                                >
                                    <input
                                        className="p-2"
                                        type="text"
                                        value={row.vatDes}
                                        disabled
                                        style={{ width: "100%", boxSizing: "border-box" }}
                                    />
                                </td>

                                {/* VAT % */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.vat}px`,
                                        minWidth: `${columnWidths.vat}px`
                                    }}
                                >
                                    <input
                                        className="p-2"
                                        type="text"
                                        value={`${row.vat || 0}%`}
                                        disabled
                                        style={{ width: "100%", boxSizing: "border-box" }}
                                    />
                                </td>

                                {/* VAT Amount */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.vatAmount}px`,
                                        minWidth: `${columnWidths.vatAmount}px`
                                    }}
                                >
                                    <input
                                        className="p-2"
                                        type="text"
                                        value={Number(row?.vatAmount || 0).toFixed(
                                            currencyPrecision || 3
                                        )}
                                        disabled
                                        style={{ width: "100%", boxSizing: "border-box" }}
                                    />
                                </td>

                                {/* Amount */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.amount}px`,
                                        minWidth: `${columnWidths.amount}px`
                                    }}
                                >
                                    <input
                                        className="p-2"
                                        disabled
                                        value={Number(row?.amount || 0).toFixed(
                                            currencyPrecision || 3
                                        )}
                                        style={{ width: "100%", boxSizing: "border-box" }}
                                    />
                                </td>

                                {/* Batch No */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.batchNo}px`,
                                        minWidth: `${columnWidths.batchNo}px`
                                    }}
                                >
                                    <input
                                        className="p-2"
                                        onWheel={(e) => e.target.blur()}
                                        type="number"
                                        value={row.batchNo}
                                        onKeyDown={preventNegativeSign}
                                        onChange={(e) =>
                                            handleBatchNo(index, e.target.value)
                                        }
                                        style={{
                                            width: "100%",
                                            boxSizing: "border-box"
                                        }}
                                    />
                                </td>

                                {/* Exp Date */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.expDate}px`,
                                        minWidth: `${columnWidths.expDate}px`
                                    }}
                                >
                                    <input
                                        className="p-2"
                                        type="date"
                                        value={
                                            row?.expDate
                                                ? row.expDate.split("T")[0]
                                                : ""
                                        }
                                        onChange={(e) =>
                                            handleDateChange(index, e.target.value)
                                        }
                                        style={{
                                            width: "100%",
                                            boxSizing: "border-box"
                                        }}
                                    />
                                </td>

                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="d-flex justify-content-between boxs">
                <div className="d-flex gap-2">
                    <div className="totalhead center">Total Amount</div>
                    <div className="field">{parseFloat(calculatedTotal)?.toFixed(currencyPrecision || 3) || '---'}</div>
                </div>
                <div>
                    <div className="totalhead center">_</div>
                </div>
                <div className="d-flex gap-2">
                    <div className="totalhead center">Total Discount</div>
                    <div className="field">{parseFloat(discountAmount)?.toFixed(currencyPrecision || 3) || '---'}</div>
                </div>
                <div>
                    <div className="totalhead center">=</div>
                </div>
                <div className="d-flex gap-2">
                    <div className="totalhead center">After Discount</div>
                    <div className="field">{(calculatedTotal - discountAmount)?.toFixed(currencyPrecision || 3) || '---'}</div>
                </div>
                <div>
                    <div className="totalhead center">+</div>
                </div>
                <div className="d-flex gap-2">
                    <div className="totalhead center">Total Vat</div>
                    <div className="field">{parseFloat(vatAmount)?.toFixed(currencyPrecision || 3) || '---'}</div>
                </div>
                <div>
                    <div className="totalhead center">=</div>
                </div>
                <div className="d-flex gap-2">
                    <div className="totalhead center">Net Amount</div>
                    <div className="field">{parseFloat(grandTotal)?.toFixed(currencyPrecision || 3) || '---'}</div>
                </div>
            </div>
        </div>
    );
};

export default ItemGridGRN;